import { render, staticRenderFns } from "./LRadio.vue?vue&type=template&id=04ef8880"
import script from "./LRadio.vue?vue&type=script&lang=js"
export * from "./LRadio.vue?vue&type=script&lang=js"
import style0 from "./LRadio.vue?vue&type=style&index=0&id=04ef8880&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports